exports = module.exports = require("../../../../../../textelements/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-tiny{font-size:.7em}.text-small{font-size:.85em}.text-big{font-size:1.4em}.text-huge{font-size:1.8em}", ""]);

// exports
